const getHeightInPixels = (singleLayoutData) => {
    return singleLayoutData?.componentLayout?.height?.type === 'px'
        ? singleLayoutData?.componentLayout?.height?.value
        : undefined;
};
const getWidthInPixels = (singleLayoutData) => {
    return singleLayoutData?.componentLayout?.width?.type === 'px'
        ? singleLayoutData?.componentLayout?.width?.value
        : undefined;
};
const isFixedPosition = (singleLayoutData) => {
    return (singleLayoutData?.itemLayout?.type === 'FixedPositionItemLayout' ||
        singleLayoutData?.itemLayout?.type === 'FixedItemLayout');
};
export { getHeightInPixels, getWidthInPixels, isFixedPosition };
//# sourceMappingURL=singleLayoutUtils.js.map